import styled from 'styled-components';

import { IOcAppTheme, OcColors } from '../../config/ocTheme';

export const CardContainer = styled.div<{ $isClickable: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  position: relative;
  min-width: 0px;
  word-wrap: break-word;
  border-radius: 4px;
  flex-direction: row;
  height: 100%;

  background-color: ${({ theme }) => theme.color.assistantMessageBG};
  
  filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.44));
  -webkit-filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.44));

  cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'default')};
  transition: box-shadow 0.2s;

  &:hover, &:focus, &:focus-within {
    box-shadow: ${({ $isClickable }) =>
      $isClickable ? '0 2px 8px rgba(0, 0, 0, 0.1)' : 'none'};

    a {
      outline: none;
      outline-offset: 0;
    }

    h3 {
      color: ${({ $isClickable, theme }) => $isClickable
        ? (theme as IOcAppTheme).color.sourceLinkHover || (theme as IOcAppTheme).color.buttonBG || theme.color.chatPanelBG
        : theme.color.assistantMessage } !important;
      text-decoration: ${({ $isClickable }) => $isClickable 
        ? 'underline'
        : 'none'};
    }
  }
`;

export const OrdinalColumn = styled.div`
  min-width: 24px;
  max-width: 24px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;

  background-color: ${({ theme }) => (theme as IOcAppTheme).color.secondaryBG || OcColors.bg2};
  color: ${({ theme }) => (theme as IOcAppTheme).color.textSecondary || OcColors.defaultText};

  font-size: ${({ theme }) => theme.font.size.medium};
  font-weight: ${({ theme }) => theme.font.weight.medium};

  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 8px;
  padding-bottom: 8px;
  flex-shrink: 1;
`;

export const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 8px;
  flex-grow: 1;
`;

export const Title = styled.h3`
  margin: 0 !important;
  font-size: ${({ theme }) => theme.font.size.medium} !important;
  font-weight: ${({ theme }) => theme.font.weight.semiBold} !important;
  color: ${({ theme }) => theme.color.assistantMessage} !important;
  line-height: 1.4 !important;
`;

export const BadgeContainer = styled.div`
  margin-top: 4px;
`;

/**
 * Visible link for the source title
 */
export const TitleLink = styled.a`
  color: inherit;
  flex-grow: 1;
`;
